import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const actionsPreviewManager = {
  getActionsPreview(url: any, params: any) {
    return axiosInstance.v2.post(url, params);
  }
};

export default actionsPreviewManager;
